import Blue from "~/core";

new Blue({
	name: 'Cookies',
	selector: ".cookies",
	setup(cookies) {
		const closeBtn = cookies.querySelector(".cookies__close");
		const accept = cookies.querySelector(".cookies__accept");
		const ctaLink = cookies.querySelector(".cookies__cta-link");
		const cookieArr = decodeURIComponent(document.cookie).split(";");

		function getCookie(cname) {
			var name = cname + "=";
			var decodedCookie = decodeURIComponent(document.cookie);
			var ca = decodedCookie.split(';');
			for(var i = 0; i <ca.length; i++) {
				var c = ca[i];
				while (c.charAt(0) == ' ') {
					c = c.substring(1);
				}
				if (c.indexOf(name) == 0) {
					return c.substring(name.length, c.length);
				}
			}
			return false;
		}

		function setCookie(cname, cvalue, exdays) {
			var d = new Date();
			d.setTime(d.getTime() + (exdays*24*60*60*1000));
			var expires = "expires="+ d.toUTCString();
			document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
		}

		if (!getCookie("acceptedCookies")) {
			setTimeout(() => {
				cookies.classList.add("cookies--active");
				closeBtn.setAttribute("tabindex", 1);
				ctaLink.setAttribute("tabindex", 1);
				accept.setAttribute("tabindex", 1);
			}, 1200);
		}

		const acceptCookies = () => {
			cookies.classList.remove("cookies--active");
			setCookie("acceptedCookies", true, 365);
		}
		const rejectCookies = () => {
			cookies.classList.remove("cookies--active");
			setCookie("acceptedCookies", false, 365);
		}

		this.$addEvents(closeBtn, "click enter", rejectCookies);
		this.$addEvents(accept, "click enter", acceptCookies);

	}
});